import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToSection = () => {
    const location = useLocation();

    useEffect(() => {
        const section = location.state?.section;

        if (!section) return;

        let attempts = 0;
        let interval;

        const scrollToElement = () => {
            const element = document.getElementById(section);

            if (element) {
                const top =
                    element.getBoundingClientRect().top +
                    window.scrollY -
                    100;

                window.scrollTo({
                    top,
                    behavior: 'smooth',
                });

                return true;
            }

            return false;
        };

        interval = setInterval(() => {
            attempts++;

            if (scrollToElement() || attempts >= 30) {
                clearInterval(interval);
            }
        }, 100);

        return () => clearInterval(interval);
    }, [location.pathname, location.key, location.state]);

    return null;
};

export default ScrollToSection;